import { render, staticRenderFns } from "./NoticeListIframe.vue?vue&type=template&id=6bc06d57&"
import script from "./NoticeListIframe.vue?vue&type=script&lang=ts&"
export * from "./NoticeListIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports